import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Skeleton } from 'primereact/skeleton';

const PatientCarusel = ({ caruselPatients, setAddPatientDialogVisible, t }: any) => {
    const navigate = useNavigate();
    const lang = localStorage.getItem("i18nextLng") === "en" ? "en-US" : "tr-TR";


    const responsiveOptions = [
        {
            breakpoint: '1585px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '950px',
            numVisible: 1,
            numScroll: 1
        },
    ];

    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1460);

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1460);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    function formatVisitDate(dateString: any) {
        if (!dateString) return "---";

        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "---";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    const viewPatientDetails = (rowData: any) => {
        localStorage.setItem("patient", JSON.stringify(rowData));
        navigate({ pathname: "/mobithera/prescription" })
    }

    const patientTemplate = (patient: any) => {
        if (patient.empty) {
            return (
                <div className='flex justify-content-start align-items-center mx-2 h-8rem p-4 gap-4'
                    style={{
                        whiteSpace: "nowrap", backgroundColor: "#FFFFFF",
                        borderRadius: "24px", boxShadow: "0 4px 4px -1px rgba(45, 57, 103, 0.05), 0 4px 10px -1px rgba(45, 57, 103, 0.1)"
                    }}>
                    <img src="/emptyPatient.svg"
                        style={{ width: "5rem", height: "5rem", borderRadius: "24px", objectFit: "contain" }} />
                    <div className='flex flex-column gap-4 w-full'>
                        <Skeleton height="2rem"  borderRadius="16px"></Skeleton>

                        <Skeleton height="1rem"  borderRadius="16px"></Skeleton>
                    </div>
                </div>
            )
        } else {
            return (
                <div onClick={() => viewPatientDetails(patient)} className='flex justify-content-start align-items-center mx-2 h-8rem p-4 gap-4 clickableCarouselDivPatient'
                    style={{
                        whiteSpace: "nowrap", backgroundColor: "#FFFFFF",
                        borderRadius: "24px", boxShadow: "0 4px 4px -1px rgba(45, 57, 103, 0.05), 0 4px 10px -1px rgba(45, 57, 103, 0.1)"
                    }}>
                    <img src={patient.gender === "Male" ? "/man.png" : "/Female.png"}
                        style={{ width: "5rem", height: "5rem", borderRadius: "24px", objectFit: "contain" }} />
                    <div className='flex flex-column gap-2'>
                        <p className='text-lg m-0 font-bold'
                            style={{
                                color: "#2D3967",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "10rem",
                            }}>{patient.firstName + " " + patient.lastName}</p>

                        <div className='flex justify-content-start gap-6'>
                            <div className='flex flex-column'>
                                <p className='m-0 font-bold' style={{ color: "#2D3967" }}>{t('age')}</p>
                                <p className='m-0 text-sm' style={{ color: "#727A99" }}>{patient.age}</p>
                            </div>
                            <div className='flex flex-column'>
                                <p className='m-0 font-bold' style={{ color: "#2D3967" }}>{t('lastVisitDate')}</p>
                                <p className='m-0 text-sm' style={{ color: "#727A99" }}>{formatVisitDate(patient.lastVisitDate)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (

        <div className='grid'>
            <div className='col-12 md:col-2'>
                <div onClick={() => setAddPatientDialogVisible(true)} className='px-4 flex justify-content-center align-items-center h-8rem gap-4 clickableCarouselDivPatient'
                    style={{
                        backgroundColor: "#FFFFFF",
                        borderRadius: "24px",
                        boxShadow: "0 4px 4px -1px rgba(45, 57, 103, 0.05), 0 4px 10px -1px rgba(45, 57, 103, 0.1)",
                    }}>
                    <img src="/addPatientIconBlue.svg" style={isWideScreen ? { width: "4rem", height: "4rem" } : { width: "5rem", height: "5rem" }} />
                    <div className='flex flex-column  align-items-center'>
                        {isWideScreen && <p className='text-xl m-0 font-bold' style={{ color: "#2D3967" }}>{t("createNewPatient")}</p>}
                    </div>

                </div>
            </div>

            <div className='col-10 sm:col'>
                <Carousel value={caruselPatients} numVisible={3} numScroll={1} itemTemplate={patientTemplate} responsiveOptions={responsiveOptions} />
            </div>

        </div>




    )
}

export default PatientCarusel